
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, shareReplay } from "rxjs";

import { environment } from "../environments/environment";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import { User } from "../models/user.model";
import { NewUser } from "../models/new-user.model";
import { UserItemType } from "../types/item-type.type";

@Injectable({
    providedIn: 'root'
})

export class UsersService {

    public userTypes: UserItemType[] = [
        {
            value: 0,
            name: 'Pracownik',
            userCardName: 'User'
        },
        {
            value: 1,
            name: 'Admininstrator',
            userCardName: 'Admin'
        },
        {
            value: 100,
            name: 'Super Admininstrator',
            userCardName: 'S.Admin'
        }
    ];

    // Do usunięcia
    getUserTypes() {
        return this.userTypes;
    }

    public users: User[] = [];
    public currentUser: User = new User(
        0, "", "", "", 0, "");

    setCurrentUser(user: User) {
        this.currentUser = user;
    }

    getCurrentUser() {
        return this.currentUser;
    }

    getUsers() {
        return this.users;
    }

    constructor(
        public http: HttpClient,
        private authService: AuthService,
        private router: Router
    ) {
    }

    fetchUsers() {
        const endpoint = environment.apiUrl + "/api/users/list";

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    getUser(id: number) {
        const endpoint = environment.apiUrl + "/api/users/" + id;

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    getUserByToken() {
        const endpoint = environment.apiUrl + "/api/users/getByToken";
        console.log("getUserByToken", this.authService.getToken())

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.get(
            endpoint,
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            })
    }

    getUserByProvidedToken(token: string) {
        const endpoint = environment.apiUrl + "/api/users/getByToken";

        console.log("getUserByToken", this.authService.getToken())

        if (token.length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + token

        return this.http.get(
            endpoint,
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            })
    }

    updateUser(user: any) {
        const endpoint = environment.apiUrl + "/api/users/update/" + user.id;

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(endpoint, user, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    addUser(user: any) {
        const endpoint = environment.apiUrl + "/api/users/add";

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        //return this.http.post(endpoint, product, {headers: new HttpHeaders().set("X-Recbot-Api-Key", environment.apiKey)})
        return this.http.post(endpoint, user, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    deleteUser(user: User) {
        const endpoint = environment.apiUrl + "/api/users/delete/" + user.id;
        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.delete(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    checkIfUsernameExists(email: string) {
        const endpoint = environment.apiUrl + "/api/users/checkIfExists/" + email;

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    sendInvitation(email: string, role: number) {
        const endpoint = environment.apiUrl + "/api/invitations";
        const body = {
            email: email,
            role: role
        };

        const bearerToken = "Bearer " + this.authService.getToken()
        
        return this.http.post(endpoint, body, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    getInvitationList(status: string, page: number, per_page: number){
        const endpoint = environment.apiUrl + "/api/invitations";

        const bearerToken = "Bearer " + this.authService.getToken()

        let params = new HttpParams()
            .set('status', status.toString())
            .set('page', page)
            .set('per_page', per_page);

        return this.http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken), params: params})
    }

    resendInvitation(id: number) {
        const endpoint = environment.apiUrl + "/api/invitations/" + id + "/resend";

        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.post(endpoint, null, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    cancelInvitation(id: number) {
        const endpoint = environment.apiUrl + "/api/invitations/" + id;

        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.delete(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    getInvitation(id: number) {
        const endpoint = environment.apiUrl + "/api/invitations/" + id;

        const bearerToken = "Bearer " + this.authService.getToken();
        
        return this.http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    getRoles() {
        const endpoint = environment.apiUrl + "/api/roles";

        const bearerToken = "Bearer " + this.authService.getToken();

        return this.http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken)}).pipe(shareReplay(1));
    }

}